/* monitoring: the dashboard, the monitoring page and one match under review —
 * translated in the Wave 3 pass (2026-09-30). Mirrors en/monitoring.ts. */
export default {
  dash: {
    subtitle: 'Ce que la surveillance a trouvé dans votre portefeuille.',
    updated: 'dernière analyse {when}',
    addTrademark: 'Ajouter une marque',
    kpi: {
      label: "Vue d'ensemble",
      watched: 'Marques surveillées',
      watchedOf: 'sur {total}',
      unwatched: '{n} sans aucune surveillance',
      matches: 'Correspondances trouvées',
      highRisk: 'Correspondances à risque élevé',
      closeWithin: 'expire sous 14 jours | expirent sous 14 jours',
      nextWindow: 'Prochain délai : {when}',
    },
    recent: {
      title: 'Dernières correspondances',
      viewAll: 'Voir les {n}',
      col: {
        detected: 'Détectée',
        protected: 'Protégée',
        risk: 'Risque',
        registry: 'Registre',
        classes: 'Classes',
        deadline: 'Échéance',
        status: 'Statut',
      },
    },
    deadlines: {
      title: 'Échéances à venir',
      badge: '{n} à risque élevé sous 14 jours',
      open: 'Ouvrir cette correspondance',
      viewAll: 'Toutes les correspondances par échéance',
    },
    registryLastScan: '· dernière analyse {when}',
  },

  mon: {
    subtitle: {
      matched:
        'marque publiée rapprochée de votre portefeuille | marques publiées rapprochées de votre portefeuille',
      across: 'Sur',
      ofYours: 'de vos marques',
      registries: '{n} registre | {n} registres',
    },
    lastScan: 'Dernière analyse : {when}',
    yours: 'Votre marque',
    trademarks: '{n} marque | {n} marques',
    filters: 'Filtres',
    addToMonitoring: 'Ajouter à la surveillance',
    kpi: {
      label: 'Synthèse des correspondances',
      total: 'Correspondances détectées au total',
      judged: '{n} lues par le juge IA',
      highHint: 'À examiner · {n} expirent sous 14 jours',
      medHint: 'Examen recommandé',
      lowHint: 'À lire quand le temps le permet',
    },
    filter: {
      window: 'Pouvez-vous encore agir ?',
      windowOpen: 'Délai encore ouvert',
      windowUnknown: 'Aucun délai publié',
      windowClosed: 'Délai expiré',
      windowAll: 'Tout afficher',
      risk: 'Risque',
      registry: 'Registre',
      state: "État de l'examen",
    },
    state: {
      new: "En attente d'examen",
      reviewed: 'Examinée',
      dismissed: 'Écartée',
      escalated: 'Transmise pour opposition',
    },
    toolbar: {
      shown: '{n} affichées',
      grouped: 'Regroupées par marque protégée',
      sortLabel: 'Ordre de tri',
      sort: "Échéance la plus proche d'abord",
    },
    intro: {
      bands:
        "Chaque bande grisée ci-dessous est l'une de vos marques. Les lignes en dessous sont des marques relevées par l'analyse dans les bulletins des registres, susceptibles d'entrer en conflit avec elle.",
      openOnly:
        "Seules sont affichées celles dont le délai d'opposition n'est pas expiré — {link}, y compris {n} dont le délai est expiré.",
      showAll: 'tout afficher ({n})',
    },
    thead: {
      detected: 'Marque détectée',
      similarity: 'Analyse de similarité',
      riskDeadline: 'Risque et délai',
      actions: 'Actions',
    },
    band: {
      toggle: 'Afficher ou masquer les correspondances de {name}',
      countWord: 'correspondance | correspondances',
      reg: 'Enr. n° {n}',
      active: 'Surveillance active',
      paused: 'Surveillance suspendue',
      notScanned: 'Pas encore analysée',
    },
    logo: 'Logo de {name}',
    empty: 'Aucune correspondance dans cette vue.',
    clearFilters: 'Effacez les filtres',
    clearHint: '{link} pour toutes les voir.',
    showing: "{shown} correspondances affichées sur {total}, échéances les plus proches d'abord.",
    row: {
      view: 'Voir le détail',
      dismiss: 'Écarter la correspondance',
    },
    dismissPrompt:
      "Pourquoi « {name} » n'est-il pas un conflit ?\n\nVotre motif est enregistré avec la correspondance. Aucun modèle n'est réentraîné avec — il sert à mesurer si l'IA avait raison, et c'est sur lui que les seuils seront ajustés plus tard.",
    rail: {
      label: 'Synthèse',
      found: "Ce que l'analyse a trouvé",
      summary: "L'analyse a relevé {matches} sur votre portefeuille, dont {high} à risque élevé.",
      matches: '{n} correspondance | {n} correspondances',
      breakdown: 'Répartition par risque',
      total: 'Toutes les correspondances',
      decided: 'Comment elles ont été tranchées',
      judged: 'Lues par le juge IA',
      judgedSub: 'Un verdict motivé',
      rule: 'Retenues par règle',
      ruleSub: 'Identiques ou quasi identiques',
      awaiting: 'En attente de votre examen',
      awaitingSub: 'Pas encore traitées',
    },
    health: {
      title: 'État de la surveillance',
      summary: '{count} marques sont surveillées. Dernière analyse : {when}.',
      count: '{n} sur {total}',
      unwatched: 'Aucune surveillance',
      unwatchedSub: "Aucun registre n'est consulté pour celles-ci",
      registries: 'Registres surveillés',
      workload: 'Charge de travail',
      awaiting: 'En attente de décision',
      awaitingSub: "Personne n'y a encore répondu",
      next: 'Prochain délai à expirer',
      nextSub: 'Parmi les correspondances sans réponse',
    },
    start: {
      title: 'Par où commencer',
      review: "Examinez d'abord {high}.",
      high: '{n} correspondance à risque élevé | les {n} correspondances à risque élevé',
      closingCount: "{n} d'entre elles",
      closingTail:
        "a un délai d'opposition qui expire sous 14 jours. | ont un délai d'opposition qui expire sous 14 jours.",
      button: 'Examiner les correspondances à risque élevé',
    },

    deadline: {
      today: "Expire aujourd'hui",
      closedDays: 'Expiré depuis {n} jour | Expiré depuis {n} jours',
      closedMonths: 'Expiré depuis {n} mois',
      closedYears: 'Expiré depuis {n} an | Expiré depuis {n} ans',
      on: 'Échéance : {date}',
    },
    since: {
      never: 'jamais',
      now: "à l'instant",
      minutes: 'il y a {n} min',
      hours: 'il y a {n} h',
      days: 'il y a {n} jour | il y a {n} jours',
    },
    tag: {
      filed: 'Déposée le {date}',
      judge: 'IA · {model}',
      judgeUnnamed: 'Juge IA',
      rule: 'Retenue par règle',
    },
    channel: {
      visual: 'Visuel',
      aural: 'Phonétique',
      phonetic: 'Phonétique',
      conceptual: 'Sens',
      name_semantic: 'Sens',
      goods: 'Produits et services',
      name_trigram: 'Graphie',
      name_contains: 'Inclusion',
      name_stem: 'Radical commun',
      name_edit: 'Graphie proche',
      logo_text: 'Mots du logo',
      logo_visual: 'Aspect',
      logo_phash: 'Même image',
      gate: 'Seuil',
      rerank: 'Reclassement',
    },
    belt: {
      edit: '{a} et {b} diffèrent de {n} lettre sur {letters} | {a} et {b} diffèrent de {n} lettres sur {letters}',
      stemStart: 'Les deux commencent par {stem}',
      stemInside: 'Les deux contiennent le radical {stem}',
      stemCoverage: '{text}, soit {pct} % du mot',
      contains: '{inner} figure dans {outer}',
      sound: 'Les deux noms partagent une clé phonétique ({keys})',
      spelling: 'Les graphies se recoupent (similarité {n})',
      meaning: 'Les noms ont un sens proche (similarité {n})',
      goods: 'Les produits et services sont proches (similarité {n})',
      logoWords: 'Les mêmes mots figurent dans les logos : {words}',
      samePicture:
        "Les images sont quasi identiques ({n} bit d'écart) | Les images sont quasi identiques ({n} bits d'écart)",
      looksAlike: 'Les images se ressemblent (similarité {n})',
      rerank: 'Note du modèle de reclassement : {score} ({band})',
      rerankBand: 'Modèle de reclassement : {band}',
    },
    rerankBand: {
      floor: 'sous la limite',
      gray: 'zone grise',
      top: 'tranche haute',
      unscored: 'non noté',
    },
    decision: {
      ceiling: "Remontée d'office",
      surface: 'Remontée',
      gray: 'Zone grise',
      floor: 'Sous le seuil',
      dismiss: 'Écartée',
    },
    gate: {
      identical: 'nom identique',
      edits: 'nom à {n} lettre près | nom à {n} lettres près',
      sound: 'même sonorité à longueur égale',
      picture: "même image ({n} bit d'écart) | même image ({n} bits d'écart)",
      floor: 'tous les signaux sous {line}',
    },
    escalation: {
      notDismissed: "Non transmise : le premier modèle ne l'a pas écartée",
      below: 'Non transmise : note de reclassement {score}, inférieure à {line}',
      noSecond:
        'Non transmise : note de reclassement {score} ≥ {line}, mais aucun second modèle disponible',
      escalated:
        "Transmise au second modèle : le premier l'a écartée, note de reclassement {score} ≥ {line}",
    },
    markType: {
      word: 'Marque verbale',
      figurative: 'Marque figurative',
      combined: 'Marque semi-figurative',
      sound: 'Marque sonore',
      other: 'Autre',
    },
    brandStatus: {
      registered: 'Enregistrée',
      pending: 'En cours',
      filed: 'Déposée',
      published: 'Publiée',
      opposed: 'Sous opposition',
      cancellation_procedure: "Procédure d'annulation",
      expired: 'Expirée',
      refused: 'Refusée',
      withdrawn: 'Retirée',
    },
    feedback: {
      confirm: 'Conflit confirmé',
      escalate: 'Transmise pour opposition',
      dismiss: 'Écartée',
      false_positive: 'Pas un conflit',
    },
  },

  match: {
    review: 'Examen de la correspondance',
    title: '{found} contre {ours}',
    subtitle: 'Votre marque {ours} face à la publication {registry} {found}',
    previous: 'Précédente',
    next: 'Suivante',
    close: 'Fermer',
    back: 'Retour à la surveillance',
    yourMark: 'Votre marque surveillée',
    position: 'Correspondance {p} sur {total}',
    viewTrademark: 'Voir la marque →',
    compare: 'Comparaison des marques',
    found: 'Relevée dans le bulletin',
    vs: 'contre',
    field: {
      classes: 'Classes de Nice',
      registered: 'Enregistrée le',
      applicationNo: 'N° de demande',
      type: 'Type de marque',
      filed: 'Déposée le',
      registry: 'Registre',
      name: 'Dénomination',
      owner: 'Titulaire',
      registrationNo: "N° d'enregistrement",
      status: 'Statut',
      deadline: "Délai d'opposition",
      vienna: 'Codes de Vienne',
      designated: 'Pays désignés',
      found: 'Relevée le',
      reviewState: "État de l'examen",
    },
    nonePublished: 'Aucun publié',
    score: {
      judge: 'Score de risque IA',
      rules: 'Score de la règle',
      low: 'Faible',
      med: 'Moyen',
      high: 'Élevé',
      window: "Délai d'opposition",
      decidedBy: 'Tranché par',
      matchingRules: 'règles de rapprochement',
    },
    tab: {
      label: "Sections de l'examen",
      analysis: 'Pourquoi elle a été relevée',
      details: 'Les deux marques',
      timeline: 'Chronologie',
    },
    analysis: {
      judge: "Ce que l'IA a lu",
      rules: 'Ce que les règles ont trouvé',
      judgeIntro:
        "Un modèle a lu cette paire comme le ferait un examinateur et a donné les quatre notes ci-dessous. C'est un avis, pas une décision : il sert à placer devant vous les paires qui méritent votre temps.",
      rulesIntro:
        "Aucun modèle n'a lu cette paire. Elle est là parce que les règles de rapprochement ci-dessous se sont déclenchées — chacune est une vérification que vous pouvez refaire vous-même.",
      firstReading: 'Première lecture — {model} : {verdict}',
      surfaced: "Remontée d'office :",
      shared: 'Classes de Nice communes : {list}',
    },
    decide: {
      title: 'Votre décision',
      intro:
        "Quoi que vous décidiez, c'est enregistré avec la correspondance : c'est ainsi que nous mesurons si l'IA avait raison, et sur cette base que les seuils seront ajustés plus tard. Être d'accord tient en un clic. Ne pas l'être demande un motif, car c'est la réponse qui nous apprend quelque chose de nouveau.",
      already: 'Déjà répondu :',
      someone: "Quelqu'un",
      disagreed: '· en désaccord avec la machine',
      saving: 'Enregistrement…',
      confirm: "Oui, c'est un conflit",
      escalate: 'Conflit — à opposer',
      orDismiss: "Ou indiquez que ce n'est pas un conflit, et pourquoi :",
      reasons: 'Motif du rejet',
      own: 'Avec vos mots',
      required: '(obligatoire)',
      optional: '(facultatif)',
      placeholder:
        'p. ex. ils vendent un logiciel industriel pour le pétrole et le gaz — aucun recoupement avec notre produit grand public, malgré la même classe de Nice sur le papier.',
      hint: "Enregistré avec votre décision. Le texte libre s'ajoute au motif ci-dessus sans le remplacer, car une liste se compte et la prose non.",
      failed: "Votre réponse n'a pas été enregistrée. Réessayez dans un instant.",
      dismiss: 'Pas un conflit — écarter',
    },
    reason: {
      different_market: {
        label: 'Secteur ou marché différent',
        sub: "L'usage réel ne se recoupe pas",
      },
      weak_sound: {
        label: 'Faible proximité phonétique',
        sub: 'La graphie a pesé plus que la prononciation',
      },
      not_confusable: {
        label: 'Pas de risque de confusion',
        sub: 'Sans portée juridique en pratique',
      },
      coexists: {
        label: 'Coexistence existante',
        sub: 'Accord de coexistence déjà en place',
      },
      visual_difference: {
        label: 'La différence visuelle domine',
        sub: 'Logos ou présentation nettement distincts',
      },
      other: {
        label: 'Autre',
        sub: 'Expliquez avec vos mots',
      },
    },
    details: {
      title: 'La marque relevée dans le bulletin',
      goods: 'Produits et services dans vos classes communes',
    },
    timeline: {
      title: "Ce qui s'est passé, et quand",
      registered: '{name} enregistrée',
      filed: '{name} déposée',
      found: "Relevée par l'analyse",
      read: 'Lue par {model}',
      closes: "Expiration du délai d'opposition",
    },
    rail: {
      label: 'Synthèse de la correspondance',
      this: 'Cette correspondance',
      applicant: 'Ce déposant, ailleurs',
      applicantSummary: '{owner} a {filings} de votre portefeuille.',
      sameApplicant: 'Le même déposant',
      otherFilings: '{n} autre dépôt rapproché | {n} autres dépôts rapprochés',
      against: 'contre {brand}',
      filing: 'Ce dépôt, face à vos autres marques',
      filingSummary: 'La même demande a aussi été rapprochée de {marks}.',
      otherMarks: '{n} autre de vos marques | {n} autres de vos marques',
      othersAgainst: 'Autres contre {brand}',
      othersSummary:
        '{n} autre dépôt a été relevé contre cette marque. | {n} autres dépôts ont été relevés contre cette marque.',
      rest: 'Examiner la suite',
      nextForBrand: 'Correspondance suivante pour cette marque',
      backAll: 'Retour à toutes les correspondances',
    },
  },
} as const
